import React from 'react';
import { STAGE_LABEL, stageCls } from '../lib';

/** One lead's stage (the one ladder), as a pill. */
const StagePill: React.FC<{ stage: string | null }> = ({ stage }) => (
  <span className={`inline-block text-[11px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ${stageCls(stage ?? 'new')}`}>
    {STAGE_LABEL[stage ?? 'new'] ?? stage}
  </span>
);

export default StagePill;
